import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/sofax/text-star-white.svg")